import { SERVICE_STATUS_BY_SEVERITY } from '../constants';
import { ServiceStatus } from '../types';

type StatusHolder = string | { status };

export function getHighestStatus(
  array: StatusHolder[],
): ServiceStatus | undefined {
  const status: string[] = array
    .map((item) => (typeof item === 'string' ? item : item?.status))
    .filter((s): s is string => typeof s === 'string');

  return SERVICE_STATUS_BY_SEVERITY.find((element) =>
    status.includes(element),
  ) as ServiceStatus | undefined;
}
